// extracted by mini-css-extract-plugin
export default {"rootContainer":"InvitedUsers_rootContainer__MtG7O","project":"InvitedUsers_project__3FB7S","tableRootContiner":"InvitedUsers_tableRootContiner__QjXUs"};